/**
 * Formulace wizardu podle typu podnikání.
 *
 * Kalkulačka se narodila jako nástroj na e-shopy a zůstalo to v textech:
 * kovovýroba se dočetla o "celkových tržbách e-shopu", dostala otázku na
 * kamennou prodejnu a měla říct, kolik hodin týdně odpracuje "v e-shopu".
 * Odstranění nevhodných KROKŮ řeší kroky.js, tohle řeší jejich obsah.
 *
 * Většina textů je psaná neutrálně, aby seděla všem. Čeština totiž skloňuje
 * a dosazovat do věty podstatné jméno podle typu je křehké: "váš e-shop"
 * a "vaše výroba" se liší víc než jedním slovem. Vlastní znění dostávají
 * jen místa, kde se liší podstata otázky, ne jen její obal.
 *
 * Klíče typů musí souhlasit s core/typ_podnikani.py.
 */

const TEXTY = {
  // Co se počítá do přímých nákladů, se mezi typy liší nejvíc.
  cogs: {
    vychozi: 'Přímé náklady na to, co prodáváte. Jen náklady vázané přímo '
      + 'na prodaný výkon, ne nájem, marketing ani administrativu.',
    eshop: 'Nákupní cena prodaného zboží. Jen přímé náklady na zboží, ne '
      + 'logistiku nebo marketing. Příklad: prodáte produkt za 500 Kč '
      + 'a od dodavatele ho nakoupíte za 200 Kč, přímý náklad je 200 Kč.',
    obchod: 'Nákupní cena prodaného zboží, tedy za kolik jste zboží pořídili '
      + 'od dodavatele. Bez dopravy do prodejny a bez mezd.',
    vyroba: 'Spotřeba materiálu a energií na výrobu. Materiál, polotovary '
      + 'a energie spotřebované ve výrobě. Mzdy výrobních dělníků sem '
      + 'nedávejte, ty patří do provozních nákladů.',
    sluzby: 'Přímé náklady na zakázky: subdodávky, externí spolupracovníci '
      + 'a materiál spotřebovaný na zakázce. U čistě poradenských firem '
      + 'bývá tahle položka nulová.',
  },

  cogs_radek: {
    vychozi: 'Přímé náklady na prodaný výkon',
    eshop: 'A.1. Náklady vynaložené na prodané zboží',
    obchod: 'A.1. Náklady vynaložené na prodané zboží',
    vyroba: 'A.2. Spotřeba materiálu a energie',
    sluzby: 'A.1. Náklady vynaložené na prodané zboží  +  A.3. Služby (subdodávky)',
  },

  cogs_proc: {
    vychozi: 'Náklady vázané přímo na to, co jste prodali. Ne dopravu ani reklamu.',
    eshop: 'Nákupní cena zboží, které jste prodali. Jen samotné zboží, ne '
      + 'dopravu ani reklamu.',
    obchod: 'Nákupní cena zboží, které jste prodali. Jen samotné zboží, ne '
      + 'dopravu do prodejny ani mzdy prodavačů.',
    vyroba: 'Materiál a energie spotřebované ve výrobě. Mzdy dělníků sem '
      + 'nepatří, ty jsou v provozních nákladech.',
    sluzby: 'Subdodávky a materiál spotřebovaný na zakázkách. U poradenství '
      + 'bývá nulové, tam jsou hlavním nákladem mzdy.',
  },

  trzby_radek: {
    vychozi: 'I. Tržby z prodeje výrobků a služeb  +  II. Tržby za prodej zboží',
    eshop: 'I. Tržby z prodeje výrobků a služeb  +  II. Tržby za prodej zboží',
  },

  trzby_proc: {
    vychozi: 'Sečtěte oba řádky. To je váš roční obrat.',
    eshop: 'Sečtěte oba řádky. U e-shopu, který přeprodává zboží, bývá hlavní '
      + '„Tržby za prodej zboží". To je váš roční obrat.',
    obchod: 'Sečtěte oba řádky. U obchodu bývá hlavní „Tržby za prodej zboží". '
      + 'To je váš roční obrat.',
    vyroba: 'Sečtěte oba řádky. U výroby bývá hlavní „Tržby z prodeje výrobků '
      + 'a služeb". To je váš roční obrat.',
    sluzby: 'Sečtěte oba řádky. U služeb bývá hlavní „Tržby z prodeje výrobků '
      + 'a služeb". To je váš roční obrat.',
  },

  zasoby: {
    vychozi: 'Hodnota zásob na skladě v pořizovací ceně, bez neprodejného '
      + 'a zastaralého. Zadávejte částku, kterou by kupující našel při '
      + 'prověrce.',
    vyroba: 'Materiál, nedokončená výroba a hotové výrobky na skladě '
      + 'v pořizovací ceně, bez neprodejného a zastaralého.',
    sluzby: 'Materiál a nedokončené zakázky. U služeb bývá tahle položka '
      + 'nulová nebo velmi malá.',
  },

  // Kolik času firmě majitel věnuje. Otázka platí všem, jen se nesmí ptát
  // na e-shop.
  hodiny_tydne: {
    vychozi: 'Kolik hodin týdně ve firmě reálně odpracujete?',
  },

  hodiny_proc: {
    vychozi: 'Buďte upřímní. Když firmu řídíte 2 hodiny týdně, náhrada je '
      + 'skoro nulová. Když v ní pracujete na plný úvazek, náhrada musí '
      + 'pokrýt někoho, kdo vás nahradí.',
  },

  kvalita_uvod: {
    vychozi: 'Pár informací o tom, jak firma funguje. Vyberte u každé '
      + 'možnost, která vás nejlíp vystihuje.',
  },
};

/** Typy, kterých se týká otázka na kamennou prodejnu. */
const S_PRODEJNOU = ['eshop', 'obchod'];

/** Typy, které prodávají zboží, a mají tedy smysl otázky na jeho původ. */
const SE_ZBOZIM = ['eshop', 'obchod'];

/**
 * Text podle typu podnikání. Když pro typ vlastní znění není, vrátí
 * výchozí, které je psané tak, aby sedělo všem.
 */
export function text(klic, typ) {
  const varianty = TEXTY[klic];
  if (!varianty) return '';
  return varianty[typ] || varianty.vychozi || '';
}

/** Má se ptát na kamennou prodejnu? Strojírna ji nemá. */
export function maProdejnu(typ) {
  return S_PRODEJNOU.includes(typ);
}

/** Prodává firma zboží? Otázky na jeho původ a skladování jinak nedávají smysl. */
export function prodavaZbozi(typ) {
  return SE_ZBOZIM.includes(typ);
}
